export enum TypeLogin {
    WITH_EMAIL_CONFIRM = 0,
    WITHOUT_EMAIL_CONFIRM = 1,
    WITH_SHORTCODE = 2,
    PUBLIC_EVENT_HOME = 3
}